import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import { TaskFilterValues } from "@/pages/admin/tasks/lib/types/TaskFilterValues.interface";

export interface TaskQueryParams extends PaginationParams, TaskFilterValues {}

export const fetchTasks = async (
  params: TaskQueryParams,
): Promise<CollectionResponse<Task>> =>
  axiosInstance
    .get("/admin/tasks", { params })
    .then((response) => response.data);

export const createTask = async (data: Task): Promise<null> =>
  axiosInstance.post(`/admin/tasks`, data).then((response) => response.data);

export const updateTaskById = async (id: string, data: Task): Promise<null> =>
  axiosInstance
    .patch(`/admin/tasks/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteTaskById = async (id: string): Promise<null> =>
  axiosInstance.delete(`/admin/tasks/${id}`).then((response) => response.data);

export const fetchTaskById = async (id: string): Promise<Task> =>
  axiosInstance.get(`/admin/tasks/${id}`).then((response) => response.data);

export const completeTaskById = async (id: string): Promise<null> =>
  axiosInstance
    .post(`/admin/tasks/${id}/complete`, {})
    .then((response) => response.data);
